<template>
  <div class="checkout-vip-order">
    <PaymentMethods type="vip" :finalPrice="finalPrice" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { vipPaymentSubmitPayloadTransform } from '@/transforms/orderTransform'
import cartSummary from '@/mixins/cartSummary'

export default {
  name: 'CheckoutVipOrder',

  mixins: [cartSummary],

  components: {
    PaymentMethods: () =>
      import('@/components/payments/base/PaymentMethods'),
  },

  props: {
    isVip: {
      type: Boolean,
      default: false,
    },
    finalPrice: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapState({
      paymentId: state => state.paymentType.paymentId,
    }),
  },

  data() {
    return {}
  },

  watch: {
    paymentId(newVal) {
      if (newVal) {
        this.checkSummary()
      }
    },
  },

  methods: {
    async handleConfirmPayment() {
      const uuid =
        this.$route.params.uid || this.$route.params.orderId

      if (!uuid) {
        this.$toast.error(
          'ไม่สามารถทำรายการได้ กรุณาลองใหม่อีกครั้ง',
          {
            duration: 5000,
            position: 'top',
          },
        )
        return
      }

      const payload = vipPaymentSubmitPayloadTransform({
        payment_type_id: this.$store.state.paymentType.paymentId,
        payment_selected: this.$store.state.paymentType
          .installmentPlan,
        branch_time_id: this.$store.state.order.data?.branch_time_id,
        coupon_codes: this.$store.state.cart.coupons.map(c => c.code),
      })

      await this.$store.dispatch('order/submitVipPayment', {
        uuid,
        payload,
      })

      if (this.$store.getters['order/isError']('submit')) {
        return
      }

      this.$emit('success')
    },
  },
}
</script>

<style lang="stylus" scoped>
.checkout-vip-order {
  display: flex;
  flex-direction: column;
  gap: 26px;
}
</style>
